import { useAtomValue } from "jotai";
import { CartFill } from "react-bootstrap-icons";
import { groupParkerCartBannerAtom } from "../Data/Atoms";
import { cents, showMoney } from "../Data/Money";
import { Button } from "./Button";

const GRADIENT = "linear-gradient(135deg, #e8359a 0%, #c0116e 100%)";

export function GroupParkerFinalizeBanner() {
    const cart = useAtomValue(groupParkerCartBannerAtom);
    if (!cart || cart.pendingCount <= 0) return null;

    return (
        <div className="group-parker-finalize-banner-wrap">
            <div
                className="group-parker-finalize-banner"
                style={{ background: GRADIENT, color: "#fff", width: "100%" }}
            >
                <div className="d-flex align-items-center justify-content-between gap-3 px-4 py-3 flex-wrap">
                    <div className="d-flex align-items-center gap-2 gap-md-3 flex-wrap flex-grow-1">
                        <div className="d-flex align-items-center gap-2">
                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                style={{ width: 36, height: 36, backgroundColor: "rgba(255,255,255,0.2)" }}
                            >
                                <CartFill size={18} />
                            </div>
                            <div>
                                <div className="small text-uppercase fw-semibold" style={{ opacity: 0.85, letterSpacing: "0.04em" }}>
                                    Ready to Finalize
                                </div>
                                <div className="fw-bold fs-5">
                                    {cart.pendingCount} parker{cart.pendingCount !== 1 ? "s" : ""} · {showMoney(cents(cart.dueToday))}
                                    {!cart.isAccountsReceivable ? "*" : ""}
                                    {cart.isAccountsReceivable ? " invoiced" : " due today"}
                                </div>
                                {!cart.isAccountsReceivable && (
                                    <div className="small" style={{ opacity: 0.75 }}>
                                        *Does not include applicable fees
                                    </div>
                                )}
                                {cart.canAssignMore && (
                                    <div className="small" style={{ opacity: 0.85 }}>
                                        Assign more open spots before finalizing
                                    </div>
                                )}
                            </div>
                        </div>
                        <button
                            type="button"
                            className="btn rounded-pill px-3 py-1 flex-shrink-0"
                            style={{
                                backgroundColor: "rgba(255,255,255,0.12)",
                                color: "rgba(255,255,255,0.75)",
                                fontSize: "0.85rem",
                                border: "1px solid rgba(255,255,255,0.25)",
                            }}
                            onClick={cart.onClearCart}
                        >
                            Clear cart
                        </button>
                    </div>
                    <div className="d-flex gap-2 flex-shrink-0 ms-auto">
                        {cart.canAssignMore && (
                            <button
                                type="button"
                                className="btn fw-semibold rounded-pill px-3 py-1"
                                style={{ backgroundColor: "rgba(255,255,255,0.15)", color: "#fff", fontSize: "0.9rem", border: "1px solid rgba(255,255,255,0.35)" }}
                                onClick={cart.onAssignAnother}
                            >
                                Assign Another
                            </button>
                        )}
                        <Button
                            size="sm"
                            className="fw-semibold rounded-pill px-3 py-1"
                            style={{ backgroundColor: "#fff", color: "#a00d5a", fontSize: "0.9rem", border: "none" }}
                            onClick={cart.onFinalize}
                        >
                            Finalize
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
